export default __webpack_public_path__ + "static/media/gruppo_telegram.1fc9ce30.png";